// Shared v3 landing footer. Extracted from LandingV2 so it can be reused across
// v3-styled pages (Podcast, etc.).
import { Link } from 'react-router-dom'
import styles from './index.module.scss'
import { APP_URL, MCP_CLI_URL, DOCS_URL, CONTACT_URL } from '@/consts/Links.ts'
import wordmark from '@/assets/image/header/logo.png'

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.footerInner}>
      <div className={styles.footerBrand}>
        <img src={wordmark} alt="Vishwa" />
        <p className={styles.footerTagline}>
          Banking infrastructure for autonomous capital. Control enforced before execution.
        </p>
      </div>
      <div className={styles.footerCols}>
        <div className={styles.footerCol}>
          <span className={styles.footerColLabel}>PRODUCT</span>
          <a href={MCP_CLI_URL} target="_blank" rel="noreferrer">AI Treasury</a>
          <a href={MCP_CLI_URL} target="_blank" rel="noreferrer">AI Payments</a>
          <a href={APP_URL}>AI Vault</a>
          <a href={CONTACT_URL} target="_blank" rel="noreferrer">AI Credit</a>
        </div>
        {/*<div className={styles.footerCol}>*/}
        {/*  <span className={styles.footerColLabel}>SOLUTIONS</span>*/}
        {/*  <a href="/#primitive">Treasury Automation</a>*/}
        {/*  <a href="/#primitive">Agent Payments</a>*/}
        {/*  <a href="/#primitive">Agent Treasury</a>*/}
        {/*  <a href="/#primitive">RWA & Stablecoins</a>*/}
        {/*</div>*/}
        <div className={styles.footerCol}>
          <span className={styles.footerColLabel}>RESOURCES</span>
          <a href={DOCS_URL} target="_blank" rel="noreferrer">Docs</a>
          <Link to="/blog">Blog</Link>
          <Link to="/podcast">Podcast</Link>
          {/*<Link to="/blog">Case Studies</Link>*/}
        </div>
        <div className={styles.footerCol}>
          <span className={styles.footerColLabel}>COMPANY</span>
          <Link to="/terms-of-service">About</Link>
          <a href={CONTACT_URL} target="_blank" rel="noreferrer">Contact</a>
          <a href={CONTACT_URL} target="_blank" rel="noreferrer">Careers</a>
          {/*<a href="/#security">Security</a>*/}
        </div>
      </div>
      <p className={styles.footerDisclaimer}>
        Vishwa Ltd. is an infrastructure software provider. Vishwa is not a bank,
        broker-dealer, investment adviser, exchange, custodian, or money transmitter, and
        does not hold customer funds or private keys. Nothing on this site constitutes
        investment, legal, or tax advice.
      </p>
      <div className={styles.footerBottom}>
        <span>VISHWA - BANKING INFRASTRUCTURE FOR AUTONOMOUS CAPITAL</span>
        <span>© 2026 · VISHWA LTD. · CAYMAN ISLANDS</span>
      </div>
    </div>
  </footer>
)

export default Footer
